export type ThemeVariant = 'default' | 'purple' | 'yellow' | 'lightBlue'

export type CardVariant = ThemeVariant | 'gray' | 'dark'

export const themeVariantPageClass: Record<ThemeVariant, string> = {
  default: 'page-theme-default',
  purple: 'page-theme-purple',
  yellow: 'page-theme-yellow',
  lightBlue: 'page-theme-light-blue'
}
